import type { DocumentRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/documents/DocumentRequestedSupportingItemViewModel'
import { RequestedDocumentDialog } from '@/features/jobs/details/tax-type/info-gathering/documents/components/RequestedDocumentDialog/index'
import { observer } from 'mobx-react-lite'
import { RequestedDocumentCardContainer } from '@/features/jobs/details/tax-type/info-gathering/documents/components/RequestedDocumentCard/RequestedDocumentCardContainer'

interface RequestedDocumentDialogContainerProps {
  vm: DocumentRequestedSupportingItemViewModel
  isDisabled?: boolean
}

/**
 * Dialog container for {@link RequestedDocumentDialog}.
 */
export const RequestedDocumentDialogContainer = observer(
  function RequestedDocumentDialogContainer({
    vm,
    isDisabled,
  }: RequestedDocumentDialogContainerProps) {
    return (
      <RequestedDocumentDialog
        isOpen={vm.dialog.showing}
        title={vm.item.heading || vm.item.name}
        description={vm.item.longDescription}
        onClose={vm.dialog.close}
        imageUrl={vm.item.imageUrl}
        imageVariant={vm.item.previewUrl ? 'document' : 'decoration'}
        closeTestId={`requested-document-dialog-close-${vm.item.input.documentTypeShortId}`}
      >
        <RequestedDocumentCardContainer vm={vm} isDisabled={isDisabled} />
      </RequestedDocumentDialog>
    )
  },
)
